import React, { useEffect, useRef, useState } from "react";
import { addBlog, addCourseFees, addFacility, getColleges, getCourseCategories, getCourses, getUniversities } from "../../Services/HomeService";
import toast from "react-hot-toast";
import HttpClientXml from "../../utils/HttpClientXml";

const AddFacility = () => {
  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };


  const fileInputRef = useRef(null);
  const [universities, setUniversities] = useState([]);
  const [fetchUniversitiesLoading, setFetchUniversitiesLoading] = useState(false);
  const [colleges, setColleges] = useState([]);
  const [fetchCollegesLoading, setFetchCollegesLoading] = useState(false);
  const [courseCategories, setCourseCategories] = useState([]);
  const [fetchCourseCategoriesLoading, setCourseCategoriesLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [fetchCoursesLoading, setFetchCoursesLoading] = useState(false);
  const [uploading, setUploading] = useState(false)
  const [createLoading, setCreateLoading] = useState(false);

  const initialValues = {
    name: "",
    icon: ""
  }

  const [formData, setFormData] = useState(initialValues)

  const handleFileUpload = async (e) => {
    e.preventDefault()
    setUploading(true)
    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      console.log("KJH124", res);

      if (res?.image) {
        setFormData({ ...formData, icon: res.image })
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploading(false)
      fileInputRef.current.value = null;
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    // if (
    //   !formData?.type ||
    //   !formData?.universityId ||
    //   !formData?.collegeId ||
    //   !formData?.categoryId ||
    //   !formData?.courseDegreeId ||
    //   !formData?.eligibility ||
    //   !formData?.fees ||
    //   !formData?.applicationDate ||
    //   !formData?.courseMode ||
    //   !formData?.brochure
    // ) {
    //   toast.error("Please Enter All Fields");
    //   return;
    // }
    console.log("VFR175", formData);
    // return

    try {
      setCreateLoading(true);
      const res = await addFacility(formData);
      console.log("Facility Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setFormData(initialValues)
        setCreateLoading(false);
      } else {
        toast.error(res?.message);
        setCreateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Facility.");
      console.error("Error adding Facility:", error);
      setCreateLoading(false);
    }
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Add Facility
          </div>
          <section className="chartBox_area">
            <form
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <div className="row d-flex justify-content-center">






                <div className="col-md-6 mt-3">
                  <label htmlFor="Brochure">
                    {uploading && "Uploading "} Icon Photo
                  </label>
                  {!uploading && formData?.icon && (
                    <>
                      <img
                        src={formData?.icon}
                        alt="Photo Preview"
                        style={{ display: "block", margin: "10px 0", maxHeight: "100px" }}
                      />

                    </>
                  )}
                  <input
                    type="file"
                    ref={fileInputRef}
                    className="form-control"
                    onChange={handleFileUpload}
                    accept="image/*"
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Facility Name<span className="text-danger">*</span>
                  </label>
                  <input
                    value={formData?.name}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }));
                    }}
                    type="text"
                    id="name"
                    className="form-control"
                    placeholder="Enter Country Name"
                    required
                  />
                </div>
              </div>

              <div className=" d-flex justify-content-center">
                <button
                  disabled={createLoading}
                  type="submit"
                  className="btn mt-3"
                  style={{
                    background: "rgb(133, 218, 79)",
                    borderRadius: "13px",
                  }}
                >
                  {createLoading
                    ? "Saving data..."
                    : "Add Facility"}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </>
  );
};

export default AddFacility;
